import React from "react";
import { ListItemProps } from "@mui/material";

import { UsersIcon as GroupsIcon } from "lucide-react";
import { useCurrentUser } from "../../hooks/useCurrentUser";

import { GroupNavItemList } from "./GroupNavItemList";
import { useLocation } from "react-router-dom";
import { COACH_GROUPS_ACTIVE_ROUTE } from "../../routes/routes";
import { ExpandableNavItem } from "../item/ExpandableNavItem";

export interface GroupNavItemProps extends ListItemProps {
  minimized?: boolean;
  setDrawerMinimized?: React.Dispatch<React.SetStateAction<boolean>>;
}

export function GroupNavItem(props: GroupNavItemProps) {
  const { className, minimized, setDrawerMinimized } = props;
  const user = useCurrentUser();
  const location = useLocation();
  const active = location.pathname.includes("/groups");

  const totalCount = user?.groupsCount;

  return (
    <ExpandableNavItem
      className={className}
      icon={<GroupsIcon />}
      label="Groups"
      active={active}
      coachRedirectPath={COACH_GROUPS_ACTIVE_ROUTE}
      totalCount={totalCount}
      minimized={minimized}
      setDrawerMinimized={setDrawerMinimized}
      children={<GroupNavItemList />}
    />
  );
}